import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'sumProperty'})
export class SumPropertyPipe implements PipeTransform {
    transform(collection: any[], prop: string): number {
        return collection.reduce((acc, cv) => acc + cv[prop], 0);
    }
}
